import React from 'react';
import { Spin } from 'antd';

const LandingPage = ({ onStart, imagesPreloaded = true }) => {
    return (
        <div className="flex flex-col items-center justify-center min-h-[80vh] px-4 animate-fadeIn">
            <div className="text-center max-w-2xl bg-white/50 backdrop-blur-sm p-10 rounded-2xl">
                <h1 className="large-gradient-heading text-[3rem] md:text-[4rem] mb-4 brand-font font-light tracking-wide">
                    Crystal Report
                </h1>

                <div className="h-[2px] w-24 bg-gradient-to-r from-[var(--color-brand)] to-[var(--color-highlight)] mx-auto mb-8 opacity-60"></div>

                <p className="brand-text text-xl md:text-2xl text-[var(--color-subtext)] mb-12 font-light leading-relaxed">
                    Unlock your potential with behavioral insights tailored to your unique story.
                </p>

                <button
                    onClick={onStart}
                    disabled={!imagesPreloaded}
                    className={`rotating-border-button group scale-100 transition-transform duration-300 ${!imagesPreloaded ? 'opacity-70 cursor-wait' : 'hover:scale-105'}`}
                >
                    <span className="gradient-small text-lg md:text-xl px-8 py-2 block tracking-wider uppercase">
                        {imagesPreloaded ? 'Begin Assessment' : <Spin size="small" />}
                    </span>
                </button>
            </div>

            <p className="fixed bottom-8 text-[var(--color-subtext)] text-xs brand-text opacity-50 tracking-widest uppercase">
                Designed for Yancha
            </p>
        </div>
    );
};

export default LandingPage;